import React from 'react';
import SelectField from '../../../../../../web-app-components/components/SelectField';
import MenuItem from '@material-ui/core/MenuItem';

export const REGIONS = [
  { value: 'mazoji-lietuva', label: 'Mažoji Lietuva' },
  { value: 'zemaitija', label: 'Žemaitija' },
  { value: 'auksaitija', label: 'Aukštaitija' },
  { value: 'suvalkija', label: 'Suvalkija' },
  { value: 'dzukija', label: 'Dzūkija' },
];

const RegionSelectField = (props) => {
  return (
    <SelectField {...props}>
      {REGIONS.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </SelectField>
  );
};

export default RegionSelectField;

